import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  color: #212121;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #616161;
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: 1100px) {
    grid-template-columns: 1fr 360px;
    align-items: start;
  }

  .sidebar {
    order: 0;
  }

  .preview {
    order: 1;
  }

  @media (min-width: 1100px) {
    .preview {
      order: 0;
    }

    .sidebar {
      order: 1;
    }
  }
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #ededed;
  padding: 20px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #212121;
`;

export const SectionHint = styled.p`
  margin: 0;
  font-size: 13px;
  color: #7a7a7a;
`;



export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const ColorRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;

  @media (min-width: 900px) {
    grid-template-columns: 160px 1fr;
    align-items: center;
  }

  .rc-color-picker-wrap {
    width: 100%;
  }
`;

export const PreviewCard = styled.div`
  background: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 520px;
`;


export const SidebarCard = styled.div`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #ededed;
  padding: 20px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (min-width: 1100px) {
    position: sticky;
    top: 24px;
  }
`;

export const UploadWrapper = styled.div`
  .MuiFormControl-root > div > div {
    background: #ed4e2a;
    color: #fff;
    margin-right: 20px;
    border-radius: 10px;
    p {
      padding: 0 30px;
      background: url(${require("../../Assets/images/camera.png")}) no-repeat
        right center;
    }
  }
`;
